/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import NursesDataContent from "components/content/NursesDataContent";
import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";
import { FC } from "react";

/**
 * Nurse staff management page.
 * 
 * Features:
 * - Paginated list of nursing staff
 * - Nurse profile information and certifications
 * - Assignment and scheduling management
 * - Quick actions (view, edit, deactivate nurses)
 * - Integration with patient care workflows
 * 
 * @returns Nurses list page component
 */
const NursesPage: FC = () => {
  return (
    <DefaultDashboardLayout>
      <NursesDataContent />
    </DefaultDashboardLayout>
  );
};
export default NursesPage;

